export class OrderHelper {

public static prettyPrintState(state: string): string {
    switch(state) {
        case 'novy': return 'Nová objednávka';
        case 'odeslany': return 'Platební údaje odeslány';
        case 'zaplaceny': return 'Objednávka zaplacena';
        default: return 'Stav neznámý';
    }
}

}


// WEBPACK FOOTER //
// ./src/classes/OrderHelper.tsx